export const getConditionColor = (value: boolean, invalid: boolean) => {
  if (value) {
    return 'green.100'
  }

  if (invalid) {
    return 'red.75'
  }

  return 'navy.25'
}
